import React, { Children } from "react"
import { createStyles, forwardRef, View } from "@design-system/core"
import { useTabsContext } from "./TabsContext"
import { TabPanelsProps } from "./types"

export const TabPanels = forwardRef<TabPanelsProps, "div">(
  (props, forwardedRef) => {
    const { id, selectedIndex } = useTabsContext()
    const { children, style, ...others } = props

    return (
      <View {...others} ref={forwardedRef} style={[styles.root, style]}>
        {Children.map(
          children,
          (child, index) =>
            React.isValidElement(child) &&
            React.cloneElement(child, {
              isSelected: index === selectedIndex,
              id: id ? `${id}--tabpanel-${index}` : undefined,
              "aria-labelledby": id ? `${id}--tab-${index}` : undefined,
            }),
        )}
      </View>
    )
  },
)

const styles = createStyles(() => ({
  root: {
    width: "100%",
  },
}))
